import { ArrowBack } from '@mui/icons-material'
import { Backdrop, Box, Button } from '@mui/material'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Preview } from './Preview'
import { Tabs } from './tabs/Index'
import { useContext, useEffect } from 'react'
import { ToolContext } from '../../../../../../../../../core/context/ToolContext'
import { SnakeLoader } from '../../../../../../../../../core/loader/SnakeLoader'
import { rqx } from '../../../../../../../../../core/request/API'
import { domain, env } from '../../../../../../../../../core/Env'
import { S3 } from '../../../../../../../../../core/transmit/S3'
import moment from 'moment'
import { Logo } from '../../../../../../../../../core/global/Icons'

const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
const ubr_pickup_address = JSON.parse(localStorage.getItem('pickup_address'))

export const CustomProduct = () => {
    const { product_state, tool_state } = useContext(ToolContext)
    const history = useHistory()
    const q = new URLSearchParams(window.location.search);
    const { prodTemplate, categoryList, subCategory, viewLoader, selectedPickupAddress, pickupAddresses } = product_state
    const { userId, __SESSION } = tool_state
    const inputs = prodTemplate.data.inputs

    const backHandler = () => {
        if (prodTemplate.data.method === 'update') {
            history.push(`/campaign/promo?type=product`)
        } else {
            history.push(`/campaign/promo?type=product&option=attract`)
        }

    }

    const validateTopBtn = () => {
        if (q.get('id') !== null) {
            const updateRequired = inputs.title.value === '' || inputs.reg_price.value === '' || inputs.facebook.value === '' || inputs.instagram.value === '' || inputs.promo_name.value === '' || inputs.start.value === '' || inputs.end.value === '' || (inputs.delivery.value === false && inputs.pickup.value === false) || (inputs.delivery.value === true && (inputs.delivery_option.value === '' || inputs.pickup_option.value === ''))
            if (updateRequired) {
                return true
            }
            if (inputs.partial.toggled) {
                if (inputs.partial.stat || updateRequired) {
                    return true
                }
            }
            return
        }

        const allRequired = inputs.title.value === '' || inputs.reg_price.value === '' || inputs.bg.type === 'default' || inputs.logo.type === 'default' || inputs.ft_img.type === 'default' || inputs.facebook.value === '' || inputs.instagram.value === '' || inputs.promo_name.value === '' || inputs.start.value === '' || inputs.end.value === '' || (inputs.delivery.value === false && inputs.pickup.value === false) || (inputs.delivery.value === true && (inputs.delivery_option.value === '' || inputs.pickup_option.value === ''))
        if (inputs.partial.toggled) {
            if (inputs.partial.stat || allRequired) {
                return true
            }
        } else {
            if (allRequired) {
                return true
            }
        }
    }

    const handlerTopBtn = (type) => {
        prodTemplate.set({ ...prodTemplate.data, submit: { modal: true, type: type, confirmed: false } })
    }

    const validatePickup = () => {
        if (inputs?.pickup_option?.value === '2') {
            return 2;
        } else if (inputs?.pickup_option?.value === '3') {
            return 3;
        } else {
            return 1;
        }
    }

    const handlerConfirmation = async (type) => {
        const pickupAddress = pickupAddresses.data[selectedPickupAddress.data]
        if (type === 'cancel') {
            prodTemplate.set({ ...prodTemplate.data, submit: { ...prodTemplate.data.submit, modal: false, confirmed: false } })
        } else {
            if (hcrmSession === null) {
                let background_photo = await S3(Array(inputs.bg.value))
                let logo = await S3(Array(inputs.logo.value))
                let featured_image = await S3(Array(inputs.ft_img.value))
                let jstr = JSON.stringify({
                    ...prodTemplate.data, inputs: {
                        ...prodTemplate.data.inputs,
                        bg: { ...prodTemplate.data.inputs.bg, link: background_photo.location },
                        logo: { ...prodTemplate.data.inputs.logo, link: logo.location },
                        ft_img: { ...prodTemplate.data.inputs.ft_img, link: featured_image.location },
                    }
                })
                localStorage.setItem('cb_product', jstr)
                let subId = env() === 'dev' || env() === 'local' ? 'c3Vic2NyaXB0aW9uXzUzMA==' : env() === 'sb' ? 'c3Vic2NyaXB0aW9uXzM3Mg==' : 'c3Vic2NyaXB0aW9uXzI2NQ=='

                window.location.href = `${domain('mp').url}/subscription/checkout/rqx?tid=${window.btoa(`tool_${process.env.REACT_APP_TID_BIZ}`)}&callback=${process.env.REACT_APP_ENV}&platform=business&subscription=${subId}&ref=unauth&auth_type=registration&entry=ubr_subtool&subcb=ubr_product`
            } else {
                if (!prodTemplate.data.submit.confirmed) {
                    prodTemplate.set({ ...prodTemplate.data, submit: { ...prodTemplate.data.submit, confirmed: true } })

                    let background_photo = inputs.bg.value
                    let logo = inputs.logo.value
                    let featured_image = inputs.ft_img.value
                    if (inputs.bg.type !== 'default') {
                        background_photo = await S3(Array(inputs.bg.value))
                    }
                    if (inputs.logo.type !== 'default') {
                        logo = await S3(Array(inputs.logo.value))
                    }
                    if (inputs.ft_img.type !== 'default') {
                        featured_image = await S3(Array(inputs.ft_img.value))
                    }
                    const body = {
                        id: prodTemplate.data.pid,
                        company_id: __SESSION.data.uaccess[0].company_id,
                        package_name: inputs.promo_caption.value,
                        promo_name: inputs.promo_name.value,
                        start_date: moment(inputs.start.value).format('YYYY-MM-DD'),
                        end_date: moment(inputs.end.value).format('YYYY-MM-DD'),
                        user_id: userId.data,
                        title: inputs.title.value,
                        designs: [{
                            logo: inputs.logo.type !== 'default' ? logo.location : logo,
                            featured_image: inputs.ft_img.type !== 'default' ? featured_image.location : featured_image,
                            background_photo: inputs.bg.type !== 'default' ? background_photo.location : background_photo,
                            price_bg: inputs.price_bg.value
                        }],
                        link: inputs.website.value,
                        buttons: inputs.button_caption.value,
                        contact_number: inputs.contact_num.value,
                        fb_link: inputs.facebook.value,
                        promo_details: inputs.promo_details.map((v) => {
                            return v.value
                        }),
                        rate: inputs.reg_price.value.replace(/,(?=\d{3})/g, ''),
                        discount: inputs.discount_percent.value,
                        total_rate: (parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) - (parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) * (parseFloat(inputs.discount_percent.value) / 100))).toFixed(2),
                        type: 1,
                        status: prodTemplate.data.submit.type === 'Save' ? 1 : 2,
                        shipping_type: inputs.delivery.value && inputs.pickup.value ? 3 : inputs.delivery.value ? 1 : 2,
                        category_id: inputs.category.value,
                        sub_category: inputs.sub_category.value,
                        free_shipping: inputs.delivery_option.value === 'free_ship' ? 1 : 0,
                        delivery_rate: inputs.delivery_option.value === 'apply_set_del' ? 1 : 0,
                        pickup_branch_name: inputs.pickup_branch_name.value,
                        street_name: pickupAddress.street_building_number,
                        area_name: pickupAddress.area,
                        address: `${pickupAddress.full_address ? pickupAddress.full_address : `${pickupAddress.street_building_number}, ${pickupAddress.area}, ${pickupAddress.city_id}, ${pickupAddress.province_id}, ${pickupAddress.barangay_id}`}`,
                        pickup_city: pickupAddress.city_id,
                        pickup_province: pickupAddress.province_id,
                        pickup_num: inputs.pickup_num.value,
                        landmark: inputs.nearest.value,
                        pickup_info: inputs.pickup_datetime.value,
                        instagram_link: inputs.instagram.value,
                        promo_limit: inputs.promo_limit.value,
                        text_promo: inputs.text_promo.value,
                        accept_partial: inputs.partial.toggled ? 1 : 0,
                        partial_amount: inputs.partial.toggled ? inputs.partial.value : '',
                        weight: Number(inputs.weight.value),
                        length: Number(inputs.length.value),
                        width: Number(inputs.width.value),
                        height: Number(inputs.height.value),
                        pickup_option: validatePickup(),
                        barangay_id: pickupAddress.barangay_id,
                        pickup_details_id: pickupAddress.id
                    }
                    // console.log("pickupAdress", pickupAddress);
                    const res = await rqx.post(`<<tool>>/${env()}/template/${prodTemplate.data.method}`, body)
                    if (res.message === 'success') {
                        prodTemplate.set({ ...prodTemplate.data, submit: { ...prodTemplate.data.submit, modal: false, confirmed: false } })
                        history.push(`/campaign/promo?type=product`)
                    }
                }
            }
        }
    }

    useEffect(() => {
        const __init = async () => {
            viewLoader.set(true)
            const cat = await rqx.get(`<<tool>>/${env()}/template/categoryread`)
            categoryList.set(cat)
            if (ubr_pickup_address) {
                prodTemplate.set(ubr_pickup_address)
            }
            if (q.get('id') !== null) {
                const r = await rqx.get(`<<tool>>/${env()}/template/view`, { id: window.atob(q.get('id')).split('_').pop() })
                const sub_cat = await rqx.get(`<<tool>>/${env()}/template/subcategory`, { category_id: r.data[0].category_id })
                subCategory.set(sub_cat)
                const dsg = JSON.parse(r.data[0].designs)[0]
                prodTemplate.set({
                    ...prodTemplate.data,
                    pid: window.atob(q.get('id')).split('_').pop(), method: 'update', pstatus: r.data[0].status,
                    inputs: {
                        ...prodTemplate.data.inputs,
                        title: { value: r.data[0].title, stat: false, msg: '' },
                        promo_caption: { value: r.data[0].package_name, stat: false, msg: '' },
                        promo_details: JSON.parse(r.data[0].promo_details).map((v) => ({ value: v, stat: false, msg: '' })),
                        reg_price: { value: r.data[0].regular_rate, stat: false, msg: '' },
                        discount_percent: { value: r.data[0].discount, stat: false, msg: '' },
                        category: { value: r.data[0].category_id, stat: false, msg: '' },
                        sub_category: { value: r.data[0].sub_category_id, stat: false, msg: '' },
                        delivery: { value: r.data[0].shipping_type === 3 ? true : r.data[0].shipping_type === 1 ? true : false, stat: false, msg: '' },
                        delivery_option: { value: r.data[0].free_shipping ? 'free_ship' : 'apply_set_del', stat: false, msg: '' },
                        pickup: { value: r.data[0].shipping_type === 3 ? true : r.data[0].shipping_type === 2 ? true : false, stat: false, msg: '' },
                        pickup_address: { value: r.data[0]?.address || '', stat: false, msg: '' },
                        pickup_num: { value: r.data[0]?.pickup_num || '', stat: false, msg: '' },
                        nearest: { value: r.data[0]?.landmark || '', stat: false, msg: '' },
                        pickup_datetime: { value: r.data[0].pickup_datetime, stat: false, msg: '' },
                        rate: { value: r.data[0].total_rate, stat: false, msg: '' },
                        bg: { value: dsg.background_photo, object: dsg.background_photo, name: 'bg', type: 'default', stat: false, msg: '' },
                        logo: { value: dsg.logo, object: dsg.logo, name: 'logo', type: 'default', stat: false, msg: '' },
                        ft_img: { value: dsg.featured_image, object: dsg.featured_image, name: 'ft_img', type: 'default', stat: false, msg: '' },
                        website: { value: r.data[0].website, stat: false, msg: '' },
                        button_caption: { value: r.data[0].buttons.split('"')[1], stat: false, msg: '' },
                        contact_num: { value: r.data[0].contact_number, stat: false, msg: '' },
                        facebook: { value: r.data[0].fb_page, stat: false, msg: '' },
                        instagram: { value: r.data[0].instagram_page, stat: false, msg: '' },
                        promo_name: { value: r.data[0].promo_name, stat: false, msg: '' },
                        start: { value: r.data[0].start_date, stat: false, msg: '' },
                        end: { value: r.data[0].end_date, stat: false, msg: '' },
                        promo_limit: { value: r.data[0].promo_limit, stat: false, msg: '' },
                        text_promo: { value: r.data[0].valid_text, stat: false, msg: '' },
                        weight: { value: r.data[0].weight, stat: false, msg: '' },
                        length: { value: r.data[0].length, stat: false, msg: '' },
                        width: { value: r.data[0].width, stat: false, msg: '' },
                        height: { value: r.data[0].height, stat: false, msg: '' },
                        partial: { value: r.data[0].partial_payment_amount, stat: false, msg: '', toggled: r.data[0].accept_partial === 1 },
                        pickup_option: { value: r.data[0].pickup_option?.toString() || '1', stat: false, msg: '' },
                        pickup_province: { value: r.data[0]?.pickup_province || '', stat: false, msg: '' },
                        pickup_city: { value: r.data[0]?.pickup_city || '', stat: false, msg: '' },
                        pickup_barangay: { value: r.data[0]?.barangay_id || '', stat: false, msg: '' },
                    }
                })
            }
            viewLoader.set(false)
        }
        __init()
        // eslint-disable-next-line
    }, [])

    return (
        <Box height="100vh" width="100%" display="flex" flexDirection="column" >
            <Box display="flex" alignItems="center" justifyContent="space-between" height={56} boxShadow="0px 0px 4px rgba(0, 0, 0, 0.12)" p={2}>
                <Box component={Button} display="flex" alignItems="center" gap={1} px={2} onClick={backHandler}>
                    <ArrowBack sx={{ color: '#009F4D', fontSize: 22 }} />
                    <Box>Back</Box>
                </Box>
                <Box display="flex" gap={2}>
                    {
                        (prodTemplate.data.pstatus === null || prodTemplate.data.pstatus !== 2) &&
                        <Box component={Button} disabled={hcrmSession === null || validateTopBtn()} onClick={() => handlerTopBtn('Save')}
                            bgcolor="#009F4D" color="#fff" borderRadius={2} width={138}
                            sx={{ ':hover': { bgcolor: '#009F4D' }, "&:disabled": { bgcolor: '#A4C5B4', color: '#E5F2EC' } }}
                        >
                            Save
                        </Box>
                    }
                    <Box component={Button} disabled={validateTopBtn()} onClick={() => handlerTopBtn('Post')}
                        bgcolor="#0876F8" color="#fff" borderRadius={2} width={138}
                        sx={{ ':hover': { bgcolor: '#0876F8' }, "&:disabled": { bgcolor: '#7993B1', color: '#F5F5F5' } }}
                    >
                        Post
                    </Box>
                </Box>
            </Box>
            <Box height="100%" width="100%" display="flex" className="overflowY">
                {
                    viewLoader.data ?
                        <Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            <Logo size={60} />
                            <Box mt={4}>
                                <SnakeLoader size="1rem" bg="#006400" distance="0.3rem" />
                            </Box>
                        </Box>
                        :
                        <>
                            <Box height="100%" width={400} boxShadow="0px 0px 4px rgba(0, 0, 0, 0.12)">
                                <Tabs product_state={product_state} />
                            </Box>
                            <Box height="100%" width="100%">
                                <Preview inputs={inputs} />
                            </Box>
                        </>
                }
            </Box>
            <Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: 3503 }} open={prodTemplate.data.submit.modal}>
                <Box display="flex" flexDirection="column" bgcolor="#fff" borderRadius={3} width={343} p={2} height={150}>
                    <Box fontSize={20} fontWeight={600} textAlign="center">{prodTemplate.data.submit.type} this Promo?</Box>
                    <Box display="flex" gap="8px" mt="auto">
                        <Box component={Button} disabled={prodTemplate.data.submit.confirmed} bgcolor="#E5F2EC" color="#009F4D" fontSize={14} fontWeight={600} border="1px solid #009F4D" width="50%" borderRadius="6px" onClick={() => handlerConfirmation('cancel')}
                            sx={{ ':hover': { color: '#009F4D', bgcolor: '#E5F2EC' } }}
                        >
                            Cancel
                        </Box>
                        <Box component={Button} bgcolor="#009F4D" color="#fff" fontSize={14} fontWeight={600} width="50%" borderRadius="6px" onClick={() => handlerConfirmation('save')}
                            sx={{ ':hover': { color: '#fff', bgcolor: '#009F4D' } }} disabled={prodTemplate.data.submit.confirmed}
                        >
                            {!prodTemplate.data.submit.confirmed ?
                                prodTemplate.data.submit.type
                                :
                                <Box display="flex" alignItems="center">
                                    {prodTemplate.data.submit.type}
                                    <SnakeLoader size="5px" bg="#fff" distance="2.5px" />
                                </Box>
                            }
                        </Box>
                    </Box>
                </Box>
            </Backdrop>
        </Box>
    )
}
